export const CATEGORIES = ["Country Decor", "Primitive Crafts", "Candles", "Wreaths & Floral", "Textiles & Linens"];

export const BLOG_TOPICS = ["Decor Tips", "Primitive History", "Seasonal Staging", "Craft Spotlights", "From the Farm"];

export const STOCK_STATUSES = ["In Stock", "Low Stock", "Made to Order", "Sold Out"];

export const STORE = {
  name: "The Olde Crow Boutique",
  address: "The Sunnyside Mall, 595 Bedford Hwy, Bedford, Nova Scotia, Canada",
  phone: "902-404-1962",
  email: "theoldecrow@gmail.com",
  hours: [
    { days: "Monday – Friday", time: "10:00 AM – 7:00 PM" },
    { days: "Saturday", time: "10:00 AM – 6:00 PM" },
    { days: "Sunday", time: "12:00 PM – 5:00 PM" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1460776960860-7adc30a4e69d?crop=entropy&cs=srgb&fm=jpg&q=85",
  storefront: "https://images.unsplash.com/photo-1724113632008-b1a21ba4c778?crop=entropy&cs=srgb&fm=jpg&q=85",
  rocker: "https://images.unsplash.com/photo-1720370048021-eb1df3446335?crop=entropy&cs=srgb&fm=jpg&q=85",
  wreath: "https://images.unsplash.com/photo-1632389449364-34af052277e3?crop=entropy&cs=srgb&fm=jpg&q=85",
  bouquet: "https://images.unsplash.com/photo-1762020378347-f8759272bb72?crop=entropy&cs=srgb&fm=jpg&q=85",
  basket: "https://images.unsplash.com/photo-1613771280204-1ccd7164fe2e?crop=entropy&cs=srgb&fm=jpg&q=85",
  candleJar: "https://images.unsplash.com/photo-1602534926569-dbbd71e702bc?crop=entropy&cs=srgb&fm=jpg&q=85",
  candleGlow: "https://images.unsplash.com/photo-1712062673279-e6494a8e8106?crop=entropy&cs=srgb&fm=jpg&q=85",
  masonJar: "https://images.unsplash.com/photo-1612375334597-58b549ee6255?crop=entropy&cs=srgb&fm=jpg&q=85",
  pots: "https://images.unsplash.com/photo-1639944139765-7fa1988bfe99?crop=entropy&cs=srgb&fm=jpg&q=85",
};
